import { styled } from '@mui/material'
import { Scroller } from '$common/scroller'

export function ForwardMenuItemsWrapper({
  children,
}: {
  children: JSX.Element[]
}) {
  return (
    <Root>
      <Grid>{children}</Grid>
    </Root>
  )
}

const Root = styled(Scroller)`
  padding: 16px 12px;
  overflow: hidden auto;
`

const Grid = styled('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 4px;
  row-gap: 4px;
`
